export function fetchLineage(termId) {
    const lineage = {
        'nodes' : {
            '1' : { id: 1, name: 'GroES-like family'},
            '2' : { id: 2, name: 'GroES-like fond'},
            '3' : { id: 3, name: 'Canonical Rossmann fold'},
            '4000029' : { id: 4000029, name: 'Quinone oxidoreductase-like'},
            '4' : { id: 4, name: 'Zinc-containing alcohol dehydrogenase-like'}
        }, 
        edges : [
            ['4000029', '1', 'is'],
            ['4000029', '4', 'is'],
            ['1', '2', 'is'],
            ['4', '3', 'is']
        ]
    };

    return lineage;
}


export function fetchSearch(query, otype, qtype) {
    const other_domains = [
        {
            type: 'fa',
            name: '1JKG B:18-28,B:136-152',
            id: 8000002,
            segments: [[18,28],[136,152]]
        },
        {
            type: 'fa',
            name: '1KOH A:300-339',
            id: 8000002,
            segments: [[300,339]]
        },
        {
            type: 'sf',
            name: '1KOH A:300-339',
            id: 8000002,
            segments: [[300,339]]
        }
    ];
    return other_domains;
}

export function fetchTerm(termId) {
    let tdata = {
        termId : termId
    };
   
    if (termId > 8000007 && termId < 8000012) {
        tdata = {
            hasStructure : false,
            termType : 'PROTEIN TYPE',
            name : 'Membrane proteins',
            description : 'Associated with membrane of a cell or organelle.',
            termRank : 1,
            termChildren : [
                {
                    id: "2000019",
                    name: "Voltage-gated potassium channels",
                    description: "oligomeric transmembrane alpha-helical proteins",
                    cnum: 3
                },
                {
                    id: "2000095",
                    name: "MgtE membrane domain-like",
                    description: "5 transmembrane helices, bundle, right-handed twist",
                    cnum: 2
                },
                {
                    id: "2000362",
                    name: "BtuC-like",
                    description: "multihelical, 10 transmembrane helices; complex architecture: helices 2-5 and 7-10 are arranged into two similar interlocking structural motifs, related by pseudo two fold symmetry",
                    cnum: 1
                },
                {
                    id: "2000951",
                    name: "ABC transporter transmembrane region-like",
                    description: "multihelical: six transmembrane helices are arranged into two three-helical interlocking motifs, related by a pseudo two fold symmetry",
                    cnum: 2
                },
                {
                    id: "2001053",
                    name: "MetI-like",
                    description: "core: 5 transmembrane helices, flattened bundle",
                    cnum: 10
                },
                {
                    id: "2001254",
                    name: "3-helical meander layer",
                    description: "3 transmembrane helices arranged in a single layer, meander",
                    cnum: 10
                }
            ],
            tClass: 'Folds'
        }
    } else if (termId < 2000000) {
        tdata = {
            hasStructure : false,
            termRank : 1,
          
            tClass : 'Folds',
            termType : 'STRUCTURAL CLASS',
            name : 'Small proteins',
            description : 'Proteins with little or no secondary structures.',
            termChildren : [
                {
                    id: "2000049",
                    name: "GATA zinc finger-like",
                    description: "contains a beta-hairpin between the two pairs of zinc ion ligands and one or more turns of helix at the C-terminus",
                    cnum: 3
                },
                {
                    id: "2000112",
                    name: "Rubredoxin-like",
                    description: "metal ion-binding fold comprising two beta-hairpins; each hairpin contains at its tip two metal ion-coordinating residues, usually, cysteines.",
                    cnum: 2
                },
                {
                    id: "2000160",
                    name: "HypF zinc finger-like",
                    description: "coordinates zinc ion with two CxxC motifs, each motif is located at the N-end of a helical turn",
                    cnum: 1
                }
            ]
        }  
    } else if (termId < 3000000 ) {
        tdata = {
            keywords : ['beta-barrel', 'greek-key', 'clockwise'],
            hasStructure : true,
            termRank : 2,
          
            termType : 'FOLD',
            name : 'Canonical Rossmann fold',
            description : '3 layers, alpha/beta/alpha, parallel beta-sheet of 6 strands, order 321456',
            termChildren : [
                {"id":"3000039","cnum":3, "name":"LDH/MDH/AglA-like","description":"formerly two-domain, now the superfamily region is the entire protein; mixed beta-sheet, 9 strands, order:321456789; the first six strands comprise canonical parallel sheet, and the last three - antiparallel sheet, twisted into a half-barrel; member families differ by the numbers and sizes of additional structural elements "},
                {"id":"3000040","cnum":3,"name":"Zinc-containing alcohol dehydrogenase-like","description":"resides in the C-terminal part; canonical parallel beta-sheet, 6 strands, order:321456; includes the helix preceding strand one and the separate C-terminal beta-alpha-beta unit, connecting this region to the N-terminal (GroES-like) part "},
                {"id":"3000042","cnum":3,"name":"Potassium channel/Rex NAD-binding domain-like","description":"region in multidomain proteins; canonical type: parallel beta-sheet, 6 strands, order:321456; swapped dimer with the C-terminal helix"},
                {"id":"3000043","cnum":3,"name":"GAPDH-like","description":"2-domain protein with an alpha+beta domain inserted after strand 6 of the Rossmann-like domain; in different families this additional domain varies in size and number of structural elements; its common core comprises a helix and 4-stranded mixed sheet with a characteristic psi-loop; the dihydrodipicolinate reductase-like family presents a minimal form of this domain "},
                {"id":"3000044","cnum":3,"name":"D-2-hydroxyacid dehydrogenase-like","description":"2 Rossmann-like domains, swapped with the C-terminal helices; the numbers of strands in each domain vary between the families; the NAD-binding site is in the C-terminal domain"},
                {"id":"3000045","cnum":3,"name":"CysG/Met8-like","description":"2 domains; domain 1 has canonical Rossman-like beta-sheet, order 321456, and also includes dimerisation subdomain, comprising the extra N-terminal beta-strand and the C-terminal beta-beta-alpha unit; domain 2 is a helical bundle of 3 or 4 helices"},
                {"id":"3000046","cnum":3,"name":"MtdA-like","description":"2 domains; the superfamily region is trimmed from the first to the last common structural elements; the coenzyme-binding domain resides in the C-terminal part, its beta-sheet topology varies slightly between the families; the N-terminal domain contains mostly parallel beta-sheet and also shows topological variations"},
                {"id":"3000056","cnum":3,"name":"Glutamyl tRNA-reductase-like","description":"3 domains; catalytic domain 1 contains ferredoxin-like fold and 3 additional helices; coenzyme-binding domain 2 has canonical parralel beta-sheet, order:321456, and extra N-terminal helix that displaces the C-terminal helix; dimerisation domain 3 contains 3 helices per subunit and forms 6-helical bundle in the dimer"},
                {"id":"3000075","cnum":3,"name":"Urocanase-like","description":""}
            ],
            alsoShared : [
                {"id":"4003990","cnum":3,"name":"TM0796-like","description":"Pfam: PF07755 (DUF1611; contains extra N-terminal domain of Rossmann fold"}
            ],
            relations : ['Parallel beta-sheet'],
            tClass : 'Superfamilies',
            termParents : [
                { 
                    id: "10000002", name:" Alpha and beta proteins (a/b)", 
                    type:"STRUCTURAL CLASS",
                    ptid: 1, 
                    ptname: "Globular proteins"
                }
            ]
        }
    } else if (termId < 4000000 ){
        tdata = {
            hasStructure : true,
            termRank : 3,
          
            linkouts: [
                {
                    type: 'superfamily',
                    name: 'Superfamily'
                }
            ],
            
            termType : 'SUPERFAMILY',
            name : 'SDR-like',
            description : 'Single domain with a parallel beta-sheet, 7 strands, order 3214567, left-handed crossover connection between strands 6 and 7',
            termChildren : [
                {"id":"4000029","cnum":0, "name":"Short-chain dehydrogenases/reductases, SDR ", description: "The family region is the same as the superfamily region and comprises the same structural elements"},
                {"id":"4000088","cnum":0,"name":"UDP-glucose 4-epimerase GalE-lke","description":"the family region is longer than the superfamily region and contains additional structural elements at the C-end"},
                {"id":"4000119","cnum":0,"name":"Ketoreductase module of polyketide syntase","description":"tandem repeat of two SDR-like domains packed together about a pseudo twofold axis; only the second domain retains the coenzyme-binding site"}   
            ],
            relations : ['hyperfamily Rossmann-like nucleotide-binding lobe'],
            tClass : 'Families',
            termParents : [
                { id: "2000148", name:"SDR-type extended Rossmann fold", type:"FOLD"}
            ],
            domains : [
                {
                    name: "Erythronolide synthase, modules 1 and 2 (EC 23.1.94) (ORF 1) (6- deoxyerythronolide B synthase I) (DEBS 1)",
                    species: "Saccharopolyspora erythraea",
                    representative: "8000377",
                    non_reps : [["2FR", "A:1657-1915"]],
                    pdb: "2FR0",
                    parts: "1657-1915:A",
                    uni: "Q03131",
                    seql: 3491,
                    iparts: "1604-1862"
                },
                {
                    name: "UDP-glucose 4-epimerase (EC 51.3.2) (Galactowaldenase) (UDP-galactose 4-epimerase)",
                    species: "Escherichia coli",
                    representative: "8000694",
                    non_reps : [
                        ["1A9Y", "A:1-263"],
                        ["1A9Z", "A:1-263"],
                        ["1KVQ", "A:1-263"],
                        ["1KVR", "A:1-263"],
                        ["1KVS", "A:1-263"],
                        ["1KVT", "A:1-263"],
                        ["1KVU", "A:1-263"],
                        ["1LRJ", "A:1-263"],
                        ["1LRK", "A:1-263"],
                        ["1LRL", "A:1-263"],
                        ["1NAH", "A:1-263"],
                        ["1NAI", "A:1-263"],
                        ["1UDA", "A:1-263"],
                        ["1UDB", "A:1-263"],
                        ["1XEL", "A:1-263"],
                        ["2UDP", "A:1-263"],
                        ["2UDP", "B:1-263"],
                        ["5GY7", "A:1-263"],
                        ["5GY7", "B:1-263"]
                    ],
                    pdb: "1UDC",
                    parts: "1-263:A",
                    uni: "P09147",
                    seql: 338,
                    iparts: "1-263"
                },
                {
                    name: "Alcohol dehydrogenase (EC 11.1.1).",
                    species: "Drosophila melanogaster",
                    representative: "8001233",
                    non_reps : [ ["1MG5","B:1-240"] ],
                    pdb: "1MG5",
                    parts: "1-240:A",
                    uni: "P00334",
                    seql: 256,
                    iparts: "2-241"
                }
            ]
        }
    } else if ( termId < 5000000 ) {
        tdata = {
            hasStructure : true,
            termType : 'FAMILY',
            name : 'Quinone oxidoreductase-like',
            description : 'PFam 111; Family region covers the entire protein; lacks a Zn-finger-like insertion in the N-terminal all-beta (GroES-like) domain, unlike the Alcohol DH-like family',
            proteinFunction : 'well characterized',
            pfamId : 111,
            linkouts : [
                {
                    id: 'PF12345',
                    type: 'pfam',
                    name: 'PFam'
                },
                {
                    id: 'PF6789',
                    type: 'pfam',
                    name: 'PFam'
                }
            ],
            
            termParents : [
                { id: "3000002", name:"GroES-like", type:"SUPERFAMILY"},
                { id: "3000040", name:" Zinc-containing alcohol dehydrogenase-like", type:"SUPERFAMILY"},
            ],
            ancestry : [

                {
                    'name': 'Quinone oxidoreductase-like',
                    'id' : '4000090',
                    'type' : 'family',
                    'parents' : [
                        {
                            'id' : '3000002',
                            'name' : 'GroES-like',
                            'type' : 'superfamily',
                            'parents' : [
                            {
                                'id' : '2000001',
                                'name' : 'GroES-like',
                                'type' : 'fold'  
                            }      
                            ]
                        },
                        {
                            'id' : '3000040',
                            'name' : 'Zinc-containing alcohol dehydrogenase-like',
                            'type' : 'superfamily',
                            'parents': [
                                {
                                    'id' : '2000005',
                                    'name' : 'Canonical Rossmann fold',
                                    'type' : 'fold'
                                } 
                            ]
                        }
                    ]
                }
            ],
            domains : [
                {
                    name: "Quinone oxidoreductase (EC 16.5.5) (NADPH:quinone reductase) (Zeta- crystallin homolog protein)",
                    species: "Escherichia coli",
                    representative: "8000821",
                    non_reps : [ ["1MG5","B:1-240"] ],
                    pdb: "1QOR",
                    parts: "A:2-327",
                    uni: "P28304",
                    seql: 325,
                    iparts: "2-327"
                }
            ]
        }
    } else {
        tdata = {  
            hasStructure : true,
            termType : 'DOMAIN',
            name : '2BCG G:8-109,236-301,400-438',
            description : 'Rab GDP-dissociation inhibitor (Rab GDI) (Secretory pathway GDP dissociation inhibitor)',
            proteinSpecies : 'Saccharomyces cerevisiae',
            termParents : [
                { id: "2000021", name:"FAD/NAD(P)-binding domain", type:"FOLD"},
            ],
            relations : ['fragment (family coverage)'],
            scopDomains: [
                { 
                    chain: "G",
                    segments: ["8-109", "236-301", "400-438"]
                }
            ],
            PDBId : '2BCG',
            repSequence : {
                'UniProtId' : "P39958",
                'PDBId' : '2BCG',
                segments: [[8,109],[236,301],[400,438]],
                sequence: "MDQETIDTDYDVIVLGTGITECILSGLLSVDGKKVLHIDKQDHYGGEAASVTLSQLYEKFKQNPISKEERESKFGKDRDWNVDLIPKFLMANGELTNILIHTDVTRYVDFKQVSGSYVFKQGKIYKVPANEIEAISSPLMGIFEKRRMKKFLEWISSYKEDDLSTHQGLDLDKNTMDEVYYKFGLGNSTKEFIGHAMALWTNDDYLQQPARPSFERILLYCQSVARYGKSPYLYPMYGLGELPQGFARLSAIYGGTYMLDTPIDEVLYKKDTGKFEGVKTKLGTFKAPLVIADPTYFPEKCKSTGQRVIRAICILNHPVPNTSNADSLQIIIPQSQLGRKSDIYVAIVSDAHNVCSKGHYLAIISTIIETDKPHIELEPAFKLLGPIEEKFMGIAELFEPREDGSKDNIYLSRSYDASSHFESMTDDVKDIYFRVTGHPLVLKQRQEQEKQ",
            }
        }
    }
    return tdata;
}
